import { render, staticRenderFns } from "./SectionManufacturerList.vue?vue&type=template&id=473903cb"
import script from "./SectionManufacturerList.vue?vue&type=script&lang=js"
export * from "./SectionManufacturerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports